import { Link, useNavigate } from "react-router-dom";
import { _post } from "../services/api.service";
import "../styles/login.css";
import { useState } from "react";
import { Button } from "@mui/material";
import logo from "../images/logo-with-caption.webp";
import StyledTextField from "../components/styled-text-field.compoment";
import { COLORS } from "../theme/theme.config";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");

  const onCodeChange = (e: any) => {
    setCode(e.target.value);
  };

  const onPasswordChange = (e: any) => {
    setPassword(e.target.value);
  };

  const handleEmailSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const email = sessionStorage.getItem("USER_EMAIL");
    const payload = {
      password,
      code,
      email,
    };
    const userData = await _post("users/verify-reset-password/", payload);
    if (userData) {
      navigate("/");
    }
  };
  return (
    <div className="outer">
      <div className="middle">
        <div className="login_form">
          <form onSubmit={handleEmailSubmit} autoComplete="off">
            <div className="mb-4">
              <img src={logo} alt="Logo" style={{ height: "40px" }} />
            </div>
            <div className="mb-3">
              <StyledTextField
                fullWidth
                label="Code"
                variant="outlined"
                required
                autoFocus
                onChange={onCodeChange}
              />
            </div>
            <div className="mb-4">
              <StyledTextField
                fullWidth
                label="Password"
                type="password"
                variant="outlined"
                required
                onChange={onPasswordChange}
              />
            </div>

            <Button
              disabled={!code && !password}
              variant="contained"
              fullWidth
              sx={{
                backgroundColor: COLORS.green,
                padding: "14px",
                borderRadius: "0",
                fontSize: "1rem",
                color: "#09091c",
                "&:hover": {
                  backgroundColor: COLORS.greenHover,
                },
                "&:disabled": {
                  backgroundColor: COLORS.greenDisabled,
                  color: "#09091c",
                },
              }}
              type="submit"
            >
              UPDATE PASSWORD
            </Button>
            <p className="sign_up mt-3">
              Back to
              <Link
                style={{
                  marginLeft: "7px",
                  color: COLORS.green,
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontSize: "13px"
                }}
                to="/login"
              >
                Login
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
